import { FindAndReplaceLinkForm } from '@carboncopyco/editor-ui';
import {
  getDecodedUrlToDisplay,
  getSelectorArguments,
} from '@carboncopyco/editor-utils';
import {
  type BlockInteractionsRule,
  type ILinkReplaceRule,
  NavigationEditSchemaType,
  type RuleApplyOnType,
} from '@carboncopyco/types';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useMemo } from 'react';
import {
  useEditor,
  useEditorMetadata,
} from '../../../context/EditorSdkProvider';
import type { IFindAndReplaceRuleState } from '../types';

export type EditControlsProps = Pick<
  IFindAndReplaceRuleState<ILinkReplaceRule>,
  'onSubmit' | 'rule' | 'rules' | 'onCancel' | 'onFocus' | 'autoFocus'
>;

export const EditControls = ({
  rule,
  onCancel,
  onFocus,
  autoFocus,
  onSubmit,
}: EditControlsProps) => {
  const flags = useFlags();
  const { location } = useEditorMetadata();
  const editorSdk = useEditor();

  const getBlockInteractionsModification = useMemo(
    () =>
      editorSdk.modifications
        .filter(
          ({ schemaType }) =>
            schemaType === NavigationEditSchemaType.blockInteractions
        )
        .map((mod) => mod.content as BlockInteractionsRule),
    [editorSdk.modifications]
  );

  const editFindAndReplace = ({
    applyOn,
    newValue,
    pageUrl,
  }: {
    applyOn: RuleApplyOnType;
    newValue: string;
    pageUrl: string;
  }) => {
    return onSubmit(
      {
        ...rule,
        newValue,
        applyOn,
        elementData: {
          ...rule.elementData,
          pageUrl: pageUrl,
        },
      },
      getSelectorArguments({
        pageUrl: pageUrl,
        href: `${rule.findBy === 'url' ? rule.oldValue : undefined}`,
        applyOn: applyOn,
        elementType: rule.replaceType,
        findBy: rule.findBy,
        textContent: rule.findBy === 'title' ? rule.oldValue : undefined,
      })
    );
  };
  return (
    <FindAndReplaceLinkForm
      internalLinkFindAndReplace={!!flags?.editorInternalLinkFindAndReplace}
      initialValues={rule}
      onSubmit={editFindAndReplace}
      submitText="Save"
      onCancel={onCancel}
      onFocus={onFocus}
      autoFocus={autoFocus}
      currentPageUrl={getDecodedUrlToDisplay(location.decodedUrl)}
      blockInteractionModification={getBlockInteractionsModification}
    />
  );
};
